module.exports = __webpack_public_path__ + "f8bf3ec472c2e039bec608629dff62d4.svg";